const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.doulong.cn/api/rayvision/web'
    : '/api/rayvision/web'

/**
 * @param {String} phone
 * @param {Number} type 1:短信 2：语音
 */
export function sendPhoneMessage(phone, type) {
  return fetch(`${BASE_URL}/message/sendPhoneMessage`, {
    method: 'POST',
    body: JSON.stringify({ phone, type }),
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => response.json())
}
/**
 * @param {String} userName
 * @param {String} phone
 * @param {String} detail
 * @param {String} company
 * @param {String} rsVcToken
 * @param {String} verificationCode
 */
export function inviteCode(userName, phone, detail, company, rsVcToken, verificationCode) {
  return fetch(`${BASE_URL}/inviteCode/save`, {
    method: 'POST',
    body: JSON.stringify({ userName, phone, detail, company, rsVcToken, verificationCode }),
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => response.json())
}
/**
 * @param {String} userName
 * @param {String} phone
 * @param {String} detail
 * @param {String} rsVcToken
 * @param {String} verificationCode
 */
export function consult(userName, phone, detail, rsVcToken, verificationCode) {
  return fetch(`${BASE_URL}/consult/save`, {
    method: 'POST',
    body: JSON.stringify({ userName, phone, detail, rsVcToken, verificationCode }),
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => response.json())
}
